import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}

/**
 * Stateless function representing a security 24h icon.
 *
 * @function
 * @param {Object} [props] - The component properties
 * @returns {JSX.Element} React component markup
 *
 * @see SvgIcon
 * @example
 * <SecurityTwentyFourHoursIcon width={24} />
 */
const SecurityTwentyFourHoursIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M18.71 18.22C16 22.26 12 23 12 23C12 23 8.1 22.31 5.29 18.22C3.93 16.23 3 14.05 3 11V6.3C3
            5.51 3.47 4.79 4.19 4.47L11.19 1.36C11.71 1.13 12.3 1.13 12.81 1.36L19.81 4.47C20.53 4.79
            21 5.51 21 6.3V11C21 14.13 19.89 16.46 18.71 18.22ZM11 9.5V8C11 7.45 10.55 7 10
            7H6.5V8.5H9.5V9.5H7.5C6.95 9.5 6.5 9.95 6.5 10.5V13H11V11.5H8V10.5H10C10.55 10.5 11 10.05
            11 9.5ZM18.5 10H17.5V7H16V10H14.5V7H13V11.5H16V13H17.5V11.5H18.5V10Z`}
        />
    </SvgIcon>
)

SecurityTwentyFourHoursIcon.defaultProps = defaultProps

export { SecurityTwentyFourHoursIcon }
